
import axios from '../wmsAxios'

// 保存
export const save = (data) => {
    return axios({
        url: '/tOrder/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tOrder/delete',
        method: 'post',
        data
    })
}

// 确认订单
export const confirmOrder = (data) => {
  return axios({
    url: '/tOrder/confirmOrder',
    method: 'post',
    data
  })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tOrder/findPage',
        method: 'post',
      data
    })
}

// 查询分页数据
export const findPageByPara = (data) => {
  return axios({
    url: '/tOrder/findPageByPara',
    method: 'post',
    data
  })
}

// 取消订单
export const cancelOrder = (data) => {
  return axios({
    url: '/tOrder/cancelOrder',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tOrder.js